import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_vm.customizedList.length > 0 ? _c('div', {
    staticClass: "carousel-banner"
  }, [_c('el-carousel', {
    attrs: {
      "trigger": "click",
      "height": "280px"
    }
  }, _vm._l(_vm.customizedList, function (item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.mallImage.cdnFilePathPc
      },
      on: {
        "click": function click($event) {
          return _vm.goDetails(item.id, 1);
        }
      }
    })]);
  }), 1), _c('div', {
    staticClass: "select-list",
    on: {
      "click": function click($event) {
        return _vm.$router.push("/consumables-terial");
      }
    }
  }, [_vm._m(0), _vm._m(1)])], 1) : _vm._e(), _vm.bannerList.length > 0 ? _c('div', {
    staticClass: "carousel-banner"
  }, [_c('el-carousel', {
    attrs: {
      "trigger": "click",
      "height": "280px"
    }
  }, _vm._l(_vm.bannerList, function (item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.mallImage.cdnFilePathPc
      },
      on: {
        "click": function click($event) {
          return _vm.goDetails(item.id, 0);
        }
      }
    })]);
  }), 1), _c('div', {
    staticClass: "select-list",
    on: {
      "click": function click($event) {
        return _vm.$router.push("/erial");
      }
    }
  }, [_vm._m(2), _vm._m(3)])], 1) : _vm._e()]), _c('Footer'), _c('BackTop', {
    attrs: {
      "isConsumables": "true"
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "select-tit"
  }, [_c('i', {
    staticClass: "iconfont iconhaocaidingzhi"
  }), _c('div', {
    staticClass: "tit"
  }, [_c('h6', [_vm._v("耗材定制")]), _c('p', [_vm._v("多种材质，尽情挑选")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('em', [_vm._v(" 去定制 "), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "select-tit"
  }, [_c('i', {
    staticClass: "iconfont icondaidayin"
  }), _c('div', {
    staticClass: "tit"
  }, [_c('h6', [_vm._v("代打印")]), _c('p', [_vm._v("多种材质，尽情挑选")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('em', [_vm._v(" 去定制 "), _c('i', {
    staticClass: "iconfont icongengduoxiangqing-copy"
  })]);
}];
export { render, staticRenderFns };